// Định nghĩa các key để phục vụ cho việc chuyển trang ở PopupTopPage
export const KEY_PAGE_POPUP = {
  LANGUAGE: 'LANGUAGE',
  HOTEL: 'HOTEL',
  SMAREGI: 'SMAREGI',
}
